import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from 'components/Input';

import {
  isRequiredFloatGreaterThan
} from 'utilities/validators';

const fisherDistributionFieldsValidator =
  isRequiredFloatGreaterThan(0);

class FisherDistributionFieldsComponent extends React.PureComponent {
  static propTypes = {
    onNumeratorChange: PropTypes.func.isRequired,
    onDenominatorChange: PropTypes.func.isRequired
  }

  render () {
    return (
      <div className="flex space-between baseline">
        <Field
          type="number"
          component={Input}
          name="numeratorDf"
          label="Numerator df"
          validate={fisherDistributionFieldsValidator}
          onChange={this.props.onNumeratorChange}
          wrapperClassName="mb-15 relative width-48"
          inputClassName="main-input__input"
        />

        <Field
          type="number"
          component={Input}
          name="denominatorDf"
          label="Denominator df"
          validate={fisherDistributionFieldsValidator}
          onChange={this.props.onDenominatorChange}
          wrapperClassName="mb-15 relative width-48"
          inputClassName="main-input__input"
        />
      </div>
    );
  }
}

export default FisherDistributionFieldsComponent;
